/* ⛔ SOUS-TITRES FRANCAIS DES VIDEOS (08/10/2026, demande de Nawal pour la
   demo Saclay du 9 octobre). Deux videos du scan (« Core Scan CREA », reprises
   dans le module de demo 147) affichent une phrase en ANGLAIS sur un carton
   noir, et rien d'autre a traduire :
     - « Que s'est-il passe ? », de 6,1 a 9,4 s : « No one reacts. Silence
       fills the room. » ;
     - « Qui ecoute vraiment ? », de 9,1 a 10,8 s : « Voices overlap. The
       discussion turns tense. »
   (cartons reperes image par image sur les vignettes Mux).
   Les videos sont hebergees chez Mux : plutot que de les refaire, on pose une
   piste de sous-titres WebVTT servie par le front (public/sous-titres/),
   affichee par defaut. La 2e reste affichee une seconde de plus que le carton,
   trop court pour etre lu.
   Une video absente de cette table n'a AUCUNE piste : rien ne change pour
   elle. Ajouter une video = deposer son .vtt et ajouter une ligne ici. */
const SOUS_TITRES = {
  '011x522Hnx41gQ00B00yxsN9MVZ7AWlLkApw602E7wzq3DY': '/sous-titres/011x522Hnx41gQ00B00yxsN9MVZ7AWlLkApw602E7wzq3DY.fr.vtt',
  'M7i01sIQ02PMkC1a41DjHXVARngnoDFsKUGeS2dhpMwBk': '/sous-titres/M7i01sIQ02PMkC1a41DjHXVARngnoDFsKUGeS2dhpMwBk.fr.vtt',
}

export const pistesSousTitres = (playbackId) => {
  const src = SOUS_TITRES[playbackId]
  return src ? [{ kind: 'subtitles', src, srcLang: 'fr', label: 'Français', default: true }] : []
}

/* hls.js gere ses propres pistes et peut laisser une piste ajoutee a la main
   en mode « disabled » : on force l'affichage des pistes francaises une fois
   le lecteur pret (sans effet sur une video sans piste). */
export const afficherSousTitres = (video) => {
  const pistes = video && video.textTracks
  if (!pistes) return
  for (let i = 0; i < pistes.length; i++) {
    if (pistes[i].language === 'fr') pistes[i].mode = 'showing'
  }
}

export default pistesSousTitres
